import { useEffect, useRef, useState } from "react";
import AppSettingForm from "../../components/administrator/AppSettingForm";
import Breadcrumb from "../../components/Breadcrumb";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_APP_SETTINGS,
  UPDATE_APP_SETTINGS,
} from "../../graphql/appSettingQueries";
import { useToast } from "../../components/Toast/toastHook";

const AppSetting = () => {
  const toast = useToast(4000);
  const formikRef = useRef();
  const [initialValues, setInitialValues] = useState({});
  const { data: appVersion } = useQuery(GET_APP_SETTINGS, {
    variables: {},
    fetchPolicy: "no-cache",
    onCompleted: (appVersion) => {
      const versions = appVersion?.getAppVersion?.appVersions;
      if (versions) {
        const ios = versions.find((version) => version.platform === "ios");
        const android = versions.find(
          (version) => version.platform === "android"
        );
        setInitialValues({
          iosVersion: ios?.version,
          iosForceUpdatable: ios?.forceUpdatable,
          androidVersion: android?.version,
          androidForceUpdatable: android?.forceUpdatable,
        });
      }
    },
    onError: (error) => {
      console.log("error in autocomplete", error);
      toast("error", error.message);
    },
  });

  const [updateAppVersion, { data, loading, error }] = useMutation(
    UPDATE_APP_SETTINGS,
    {
      onCompleted(appVersion) {
        const versions = appVersion?.updateAppVersion?.appVersions;
        if (versions) {
          const ios = versions.find((version) => version.platform === "ios");
          const android = versions.find(
            (version) => version.platform === "android"
          );
          setInitialValues({
            iosVersion: ios?.version,
            iosForceUpdatable: ios?.forceUpdatable,
            androidVersion: android?.version,
            androidForceUpdatable: android?.forceUpdatable,
          });
        }
        toast("success", `App settings updated successfully`);
      },
      onError(e) {
        toast("error", `Error! ${e.message}`);
      },
    }
  );

  const handleSave = (values, reset) => {
    const {
      iosVersion,
      iosForceUpdatable,
      androidVersion,
      androidForceUpdatable,
    } = values;

    const payload = {
      iosVersion,
      iosForceUpdatable,
      androidVersion,
      androidForceUpdatable,
    };
    updateAppVersion({
      variables: { updateAppVersionInput: payload },
    });
  };

  return (
    <div id="update-app-setting">
      <Breadcrumb pageName="App Setting" />
      <AppSettingForm
        initialValues={initialValues}
        handleSave={handleSave}
        formikRef={formikRef}
        type="edit"
        loading={loading}
      />
    </div>
  );
};

export default AppSetting;
